import { useEffect, useState, useRef } from "react";
import { BsChevronCompactLeft, BsChevronCompactRight, BsPlayCircle } from "react-icons/bs";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"
import { stateDevice,stateNavigation } from "../store";
import "../style.css";
import { useSnapshot } from "valtio";

const renderTextWithCaption = (text, isPortrait) => {
  if (!text || typeof text !== 'string') return text;
  const parts = text.split(/\s*>{2,}\s*/);
  if (parts.length < 2) return text;
  const main = parts[0].trim();
  const caption = parts.slice(1).join(' ').trim();
  return (
    <>
      {main}
      {/* InfoWindowStory.css definiert global einen bloßen `p`-Selektor
          (text-align: left), der Tailwinds mobilePortrait:text-center hier
          schlägt — Inline-Style gewinnt immer. */}
      {caption && (
        <p
          className="mt-3 italic opacity-70 text-xs mobilePortrait:text-center"
          style={isPortrait ? { textAlign: "center", alignSelf: "center" } : undefined}
        >
          {caption}
        </p>
      )}
    </>
  );
};

export default function SlidebarImageGallery({isFullScreenGallery,hideImageInGallery, imageGalleryActive, currentGalerie, currentText,currentImageTitel,currentImageLink,currentImageLinkTitel,sidebarOpen, currentIndex: controlledIndex, onIndexChange, videoFallbackTitle }) {
  const sliderRef = useRef(null);
  const [internalIndex, setInternalIndex] = useState(0);
  const [ready, setReady] = useState(false);
  const [direction, setDirection] = useState("right");
  const snapStateNavigation = useSnapshot(stateNavigation)
  const snapStateDevice = useSnapshot(stateDevice)
  // Landscape-Handy (≤1000px, quer): die Sidebar ist hier nur ~200-280px breit,
  // aber md:/lg:-Breakpoints (min-width!) greifen trotzdem und blähen Titel/Text
  // auf — deshalb eigene Kompakt-Klassen per JS-Flag statt Breakpoints.
  const isLandscapeHandy = !snapStateDevice.isPortrait && snapStateDevice.isHandy

  const isControlled = controlledIndex !== undefined && onIndexChange !== undefined;
  const currentIndex = isControlled ? controlledIndex : internalIndex;
  const setIndex = isControlled ? onIndexChange : setInternalIndex;

  // Reset gallery on change
  useEffect(() => {
    setReady(false);
    if (!isControlled) setInternalIndex(0);
    const timeout = setTimeout(() => {
      setReady(true);
      sliderRef.current?.resetTransform();
    }, 0);
    return () => clearTimeout(timeout);
  }, [currentGalerie]);

  const prevSlide = () => {
    setDirection("left");
    const isFirst = currentIndex === 0;
    const newIndex = isFirst ? currentGalerie.length - 1 : currentIndex - 1;
    setIndex(newIndex);
    sliderRef.current?.resetTransform();
  };

  const nextSlide = () => {
    setDirection("right");
    const isLast = currentIndex === currentGalerie.length - 1;
    const newIndex = isLast ? 0 : currentIndex + 1;
    setIndex(newIndex);
    sliderRef.current?.resetTransform();
  };

  const isEmpty = (!currentImageTitel || currentImageTitel.length === 0) &&
                  (!currentText || currentText.length === 0) &&
                  (!currentGalerie || currentGalerie.length === 0);

  if (isEmpty && videoFallbackTitle) {
    return (
      <div className="flex flex-col items-center justify-center w-full h-full gap-4 px-8 mt-8 text-white opacity-70">
        <BsPlayCircle size={48} />
        <div className="font-inter text-base font-thin tracking-wide text-center lg:text-2xl">
          {videoFallbackTitle}
        </div>
      </div>
    );
  }

  return (
    <div className={isLandscapeHandy
      ? "flex flex-col px-3 mt-1 items-center justify-center w-full overflow-hidden"
      : "flex flex-col px-8 mt-3  items-center  justify-center w-full lg:mt-8  overflow-hidden"}>
      {/* Image + Arrows */}
      
     {imageGalleryActive && !hideImageInGallery  && sidebarOpen && snapStateNavigation.annotationOverwrite === "" && <div className="relative flex items-center justify-center w-full h-[28vh] group bg-black ">
        <TransformWrapper
          ref={sliderRef}
          initialScale={1}
          minScale={1}
          maxScale={4}
          wheel={{ disabled: true }}
          pinch={{ disabled: false }}
          doubleClick={{ disabled: false }}
        >
          <TransformComponent>
            {ready && currentGalerie[currentIndex] && (
              <img
                key={currentIndex} // triggers animation re-render
                src={currentGalerie[currentIndex]}
                alt=""
                className={` h-[28vh] w-full object-contain rounded-xl opacity-0 animate-slide-in`}
                style={{
                  animationName: direction === "right" ? "slideInRight" : "slideInLeft",
                  animationDuration: "0.7s",
                  animationFillMode: "forwards",
                }}
              />
            )}
          </TransformComponent>
        </TransformWrapper>

        {/* Left Arrow */}
        <div
          className="font-roboto group-hover:flex absolute top-1/2 -translate-y-1/2 left-0 text-2xl rounded-full p-2 bg-black/40 text-white cursor-pointer flex items-center justify-center"
          onClick={prevSlide}
        >
          <BsChevronCompactLeft size={25} />
        </div>

        {/* Right Arrow */}
        <div
          className="group-hover:flex absolute top-1/2 -translate-y-1/2 right-0 text-2xl rounded-full p-2 bg-black/40 text-white cursor-pointer flex items-center justify-center"
          onClick={nextSlide}
        >
          <BsChevronCompactRight size={25} />
        </div>
      </div>}

      {/* Text under image */}
      <div  key={currentIndex}  >
      {(sidebarOpen || snapStateDevice.isPortrait) && (     <div   className={isLandscapeHandy
      ? "font-inter flex flex-col text-xs w-full font-thin uppercase tracking-wide h-auto pt-1 pb-0 text-white text-center opacity-0 animate-text-fade"
      : `font-inter  flex flex-col text-base  w-full  font-thin uppercase tracking-wide top-2   h-auto pt-2 pb-0 text-white text-center opacity-0 animate-text-fade
      xl:text-3xl
      lg:text-2xl
      lg:pt-6
      lg:pb-3
      lg:text-left
      md:text-left
      md:text-2xl
       md:pt-6
      md:pb-3
      mobilePortrait:text-center  mobilePortrait:w-full`}>{currentImageTitel[currentIndex]}</div>)}
{(sidebarOpen || snapStateDevice.isPortrait) && (<div className={isLandscapeHandy
  ? "font-inter font-extralight flex flex-col text-[11px] leading-4 tracking-wide text-center text-white scrollbar-custom w-full mt-1 overflow-y-auto p-0 h-[34vh]"
  : `font-inter font-extralight flex flex-col text-xs leading-5 tracking-wide text-center text-white scrollbar-custom ...
    w-full mt-2 overflow-y-auto p-0
    h-[40vh]
    lg:h-[40vh]
      lg:text-left
      md:text-left
      md:text-sm
    mobilePortrait:w-full
    mobilePortrait:text-center
    ${sidebarOpen ? 'mobilePortrait:h-[35vh]' : 'mobilePortrait:h-[20vh]'}
  `}>
  {renderTextWithCaption(currentText[currentIndex], snapStateDevice.isPortrait)}
</div>)}
</div>
   
    </div>
  );
}
